import React from 'react';
import { customEmailTemplateTypes } from 'containers/NestedContainers/Tracking/data/templates-data';

// customEmailTemplateTypes predates the Klaviyo integration and only covers 7 of the 9 event
// types — these two fill the gap with a plain label instead of a raster icon.
const FALLBACK_EVENT_LABELS: Record<string, string> = {
  ERROR: 'Delivery Exception',
  CANCELLED: 'Shipment Cancelled',
};

type EventTypeMetaSource = Record<
  string,
  { key: string; text: string; imgSrc?: string; icon?: React.FC<any> }
>;

type BuiltEventTypeMeta = Record<
  string,
  { label: string; imgSrc?: string; icon?: React.FC<any> }
>;

// Callers invoke getEventTypeMeta once per row in a render loop (template preview grids,
// notification tables) — caching per typeMap identity avoids rebuilding the same map from
// scratch on every single row on every render.
const eventTypeMetaCache = new WeakMap<
  EventTypeMetaSource,
  BuiltEventTypeMeta
>();

function buildEventTypeMeta(typeMap: EventTypeMetaSource): BuiltEventTypeMeta {
  const cached = eventTypeMetaCache.get(typeMap);
  if (cached) return cached;

  const built = Object.values(typeMap).reduce<BuiltEventTypeMeta>(
    (acc, type) => {
      acc[type.key] = {
        label: type.text,
        imgSrc: type.imgSrc,
        icon: type.icon,
      };
      return acc;
    },
    {},
  );

  eventTypeMetaCache.set(typeMap, built);
  return built;
}

export function getEventTypeMeta(
  eventType: string,
  typeMap: EventTypeMetaSource = customEmailTemplateTypes,
) {
  const eventTypeMeta = buildEventTypeMeta(typeMap);
  return (
    eventTypeMeta[eventType] || {
      label: FALLBACK_EVENT_LABELS[eventType] || eventType,
    }
  );
}
